import { createStyles, makeStyles } from '@mui/styles';
import { createTheme, Theme } from '@mui/material/styles';

const defaultTheme = createTheme()
export const useRegisterStyles = makeStyles((theme: Theme) => createStyles({
    paper: {
		padding: theme.spacing(4),
		textAlign: 'center',
		boxShadow: 'none',
		borderRadius: '4px',
		backgroundColor: '#d7d5d526'
	},
	formRoot: {
		textAlign: 'left',
		[theme.breakpoints.up('xl')]: {
			marginBottom: 24,
		}
	},
	checkboxRoot: {
		marginLeft: -12,
	},
	pointer: {
		cursor: 'pointer',
	},
	signInButton: {
		paddingLeft: '16px',
		paddingRight: '16px',
		color: theme.palette.common.white,
		fontWeight: 'bold',
		fontSize: 16,
		textTransform: 'capitalize',
	},
	error: {
		color: 'red'
	}
}), { defaultTheme }
);
